import { posthogTracker } from '@/utils/trackingPostHog';
import { useState, useEffect } from 'react';

export const usePostHogTrackerFeatureFlag = (flag: string) => {
  const [flagVariant, setFlagVariant] = useState<string | boolean | null>(null);

  useEffect(() => {
    posthogTracker.posthog?.onFeatureFlags((_, flagVariants) => {
      setFlagVariant(flagVariants[flag] ?? null);
    });
  }, [flag]);

  return flagVariant;
};
